import * as actionTypes from '../../redux/actionTypes';

const initialState = {
  expenses: null,
  wexTransactions: null,
  isLoaded: false,
  monthData: null,
  currentMonthLoaded: false,
  previousMonthLoaded: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TRIP_EXPENSES_LOADED:
      return { ...state, expenses:action.data}
    case actionTypes.WEX_TRANSACTIONS_LOADED:
      return { ...state, wexTransactions:action.data, isLoaded:action.isLoaded, monthData:action.month }
    default:
      return state;
  }
};
